<template>
    <div class="tradShippAddress">
        <div class="tablePart">
            <div class="tableTool">
                <div class="toolLeft">
                    <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                    <el-button type="primary" plain size="small" @click="deleteAllAddressInfo">批量删除</el-button>
                </div>
                <div class="toolRight">
                    <el-button type="primary" size="small" @click="toDialog('add','')"><i
                       ></i>新增收货地址
                    </el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%" @selection-change="handleSelectionChange" class="tableContent">
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="receiverName"
                    label="收货人"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="mobile"
                    label="手机号"
                    header-align="center"
                    show-overflow-tooltip
                    width="180"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="所在地区"
                    header-align="center"
                    align="center"
                    :formatter="uniteAddress"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="areaInfo"
                    label="详细地址"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="createDate"
                    label="创建日期"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">修改</el-button>
                        <el-button type="text" size="small" @click="delAddressInfo(scope.row.uuid)">删除</el-button>
                        <el-button type="text" size="small" v-if="scope.row.defaultVal==0" @click="defineDefaultVal(scope.row.uuid)">设为默认</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <trad-shipp-address-dialog ref="dialogRef"></trad-shipp-address-dialog>
    </div>
</template>

<script>
    import { getAddressList,delAddressInfo,setDefaultAddress,delAllAddressInfo } from '../../utils/interface';
    import tradShippAddressDialog from './tradShippAddressDialog'
    export default {
        data() {
            return {
                current:1,
                total: 0,
                pageSize: 8,
                tableData: [],
                multipleSelection: []
            }
        },
        components: {
            tradShippAddressDialog
        },
        created(){
            this.getAddressList();
        },
        methods: {
            uniteAddress(row, column){
                return row.province+row.city+row.district;
            },
            getAddressList(){
                let params = {
                    current:this.current,
                    pageSize:this.pageSize,
                };
                getAddressList(params).then((res)=>{
                    this.tableData = res.data;
                    this.current = res.current;
                    this.pageSize = res.pageSize;
                    this.total = res.total;
                });
            },
            // 复选框选中值
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 编辑/新增
            toDialog(type,uuid) {
                this.$refs.dialogRef.init(type,uuid);
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getAddressList();
            },
            delAddressInfo(uuid){
                let params = {
                    uuid:uuid
                };
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                delAddressInfo(params).then((res)=>{
                    this.$message.success('删除成功！');
                    this.getAddressList();
                });
                }).catch(() => {})
            },
            deleteAllAddressInfo(){
                let ids = "";
                ids = this.multipleSelection.map((item)=>{
                    return item.uuid
                }).toString();
                console.log(ids);
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delAllAddressInfo({ids:ids}).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getAddressList();
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                    });
                }).catch(() => {})
            },
            defineDefaultVal(uuid){
                let params = {
                    uuid:uuid
                };
                setDefaultAddress(params).then((res)=>{
                    this.$message.success('设置成功！');
                    this.getAddressList();
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .tradShippAddress {
        padding: 20px;

        .searchPart {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }

        .tablePart {
            .tableTool {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;

                .toolLeft {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);

                    .num {
                        color: #356FDF;
                    }

                    button {
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157EFB;
                        line-height: 30px;
                        text-align: center;

                        &:hover {
                            background: #157EFB;
                            box-sizing: border-box;
                            border: 1px solid #157EFB;
                            color: #fff;
                        }
                    }
                }

                .toolRight {
                    button {
                        // width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;

                        i {
                            padding-right: 5px;
                        }

                        &:hover {
                            background: #61a2f0;
                        }
                    }
                }
            }

            .tableContent {
                min-height: 650px;

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }

                    /deep/ .el-table__row {
                        td:first-child {
                            border-right: none;

                            .cell {
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/tradShippAddress.vue